import React from 'react';
import {Form as FormikForm, Formik, FormikHelpers, FormikValues} from 'formik';
import * as Yup from 'yup';
import PrimaryButton from '../../ui/PrimaryButton';
import TextButton from '../../ui/TextButton';
import UIInput from '../../ui/form/UIInput';
import FormSection from '../../ui/form/FormSection';
import FormField from '../../ui/form/FormField';
import UISelect from "../../ui/form/UISelect";
import UIWysiwig from "../../ui/form/UIWysiwig";
import Countries from "../../models/utils/Countries";

type FormProps = {
  backLink: string;
  onSubmit?: (input: any) => void;
}

export default function CompanyAddForm({backLink, onSubmit}: FormProps) {
  const onFormSubmit = (values: FormikValues, helpersReact: FormikHelpers<FormikValues>) => {
    helpersReact.setSubmitting(true);
    if (onSubmit) {
      onSubmit(values);
      helpersReact.setSubmitting(false);
    }
  };

  const initialValues = {
    name: '',
    country: 'AF',
    description: '',
    contact: {
      firstName: '',
      lastName: '',
      email: '',
    },
  };
  const validation = Yup.object().shape({
    name: Yup.string().required('Required'),
    country: Yup.string().required('Required').max(2, 'Must be 2-letter country code'),
    description: Yup.string(),
    contact: Yup.object({
      firstName: Yup.string().required('Required'),
      lastName: Yup.string().required('Required'),
      email: Yup.string().email().required('Required'),
    }),
  });

  return (
    <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onFormSubmit}>
      {({isSubmitting}) => (
        <FormikForm>
          <FormSection>
            <FormField id="name" label="Name">
              <UIInput name="name" id="name" className="w-full"/>
            </FormField>
            <FormField id="country" label="Country">
              <UISelect name="country" options={Countries.getSorted().filter((x) => x[0] !== '00').map((x) => ({
                value: x[0],
                label: x[1]
              }))} className={"w-full"}
                        id="country"/>
            </FormField>
            <FormField id="description" label="About">
              <UIWysiwig name="description" id="description" minHeight={150}/>
            </FormField>
          </FormSection>
          <FormSection title="Contact">
            <FormField id="contact.firstName" label="First name">
              <UIInput name="contact.firstName" id="contact.firstName" className="w-full"/>
            </FormField>
            <FormField id="contact.lastName" label="Last name">
              <UIInput name="contact.lastName" id="contact.lastName" className="w-full"/>
            </FormField>
            <FormField id="contact.email" label="Email">
              <UIInput name="contact.email" id="contact.email" className="w-full"/>
            </FormField>
          </FormSection>
          <div className="pb-28">
            <div className="grid grid-cols-6 gap-4 items-start">
              <div className="col-span-3">
                <PrimaryButton loading={isSubmitting}> Save changes</PrimaryButton>
                <TextButton onClick={() => window.location.assign(backLink)}>Cancel</TextButton>
              </div>
            </div>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}
